import { number, object, string } from "yup";

export const datePeriodSchema = object({
  offsetMonths: number()
    .integer("Must be a whole number")
    .required("Must be a number")
    .typeError("Must be a number"),
  trailingMonths: number()
    .nullable()
    .when("periodKind", {
      is: "TRAILING_MONTHS",
      then: (schema) =>
        schema
          .required("Must be a number")
          .min(1, "Must be at least 1")
          .typeError("Must be a number"),
      otherwise: (schema) => schema.nullable(),
    }),
  customStartDate: string()
    .nullable()
    .when(["periodKind", "customStartParameter"], {
      is: (periodKind: string, customStartParameter: string | null) =>
        periodKind === "CUSTOM" && customStartParameter === null,
      then: (schema) => schema.required("Select a date"),
    }),
  customEndDate: string()
    .nullable()
    .when(["periodKind", "customRangeKind", "customEndParameter"], {
      is: (
        periodKind: string,
        customRangeKind: string | null,
        customEndParameter: string | null,
      ) =>
        periodKind === "CUSTOM" && customRangeKind === "RANGE" && customEndParameter === null,
      then: (schema) => schema.required("Select a date"),
    }),
});
